module.exports = jQuery;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = external "jQuery"
// module chunks = site__horticulture vendor